

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 19 17"}, rest), [h('path', {"fill":"currentColor","fill-rule":"evenodd","d":"M2.63 17a2.587 2.587 0 0 1-2.297-1.348 2.59 2.59 0 0 1 .071-2.66L2.851 9.09c.195-.308.195-.88 0-1.18L.404 4.008a2.59 2.59 0 0 1-.07-2.66A2.597 2.597 0 0 1 2.63 0h10.108c.83 0 1.794.528 2.226 1.233l3.694 5.884c.494.793.45 2.008-.115 2.757l-4.577 6.078c-.45.599-1.352 1.048-2.103 1.048H2.63ZM1.49 1.99c-.229.423-.22.917.036 1.322l2.447 3.902c.46.74.46 1.85 0 2.59l-2.447 3.902a1.289 1.289 0 0 0-.035 1.32c.23.424.662.67 1.14.67h9.232c.336 0 .84-.255 1.043-.52L17.483 9.1c.238-.317.265-.925.053-1.26l-3.694-5.884c-.194-.317-.733-.607-1.104-.607H2.63V1.32c-.477 0-.91.247-1.14.67Z"}, [])]);
};

        